document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('bundle-form');
  if (!root) return;

  const atcButton = root.querySelector('#bundle__AddToCart');
  if (!atcButton) return;

  const notifContainer = root.querySelector('#bundle-notification');
  const modal = root.querySelector('#bundle-set-modal');

  // The Product Personalizer app hooks the click of this specific button
  // (id="AddToCart") inside a real product form — see bundle-set-modal.liquid.
  // We trigger it programmatically for the parent item instead of adding it
  // through our own AJAX call, so the app's own customization properties (and
  // whatever "price adjustment" product it adds for paid options) ride along.
  const nativeAddToCartButton = modal ? modal.querySelector('#AddToCart') : null;
  const nativeParentVariantInput = modal ? modal.querySelector('[data-bundle-parent-variant-input]') : null;
  const nativeParentBundleIdInput = modal ? modal.querySelector('[data-bundle-parent-id-input]') : null;

  let isAdding = false;

  // Only handles the notification message itself — restoring the button's text/
  // loader is the click handler's job (in a `finally`), so it happens no matter
  // what, even if there's no notification container to show a message in.
  function showNotification(message) { 
    if (!notifContainer) return;

    notifContainer.classList.add('active');
    notifContainer.textContent = message;

    clearTimeout(notifContainer._timeout);
    notifContainer._timeout = setTimeout(() => {
      notifContainer.classList.remove('active');
    }, 4000);
  }

  function pad(number) {
    return number < 10 ? `0${number}` : `${number}`;
  }

  // --- Native parent add-to-cart (Product Personalizer integration) ---

  // The children are always added (via our own AJAX) *before* this runs, so by
  // the time we trigger the native #AddToCart click, the rest of the bundle is
  // already safely in the cart. That means we no longer need to prevent or wait
  // out the form's native submission — the app can take however long it wants,
  // and whatever navigation its submission eventually causes (this form's
  // `return_to` field points it at /cart) is fine, because there's nothing left
  // for our own JS to do afterward.
  function triggerNativeParentAdd(parentVariantId, bundleId) {
    if (!nativeAddToCartButton || !nativeParentVariantInput || !nativeParentBundleIdInput) return false;

    nativeParentVariantInput.value = parentVariantId;
    nativeParentBundleIdInput.value = bundleId;
    nativeAddToCartButton.click();

    return true;
  }

  const tierRadios = root.querySelectorAll('.bundle-tier-card__radio');
  const tierMessage = root.querySelector('.bundle-tier-picker .field-message');
  const setCards = root.querySelectorAll('.bundle-set-card');
  const modalTriggerButton = root.querySelector('.bundle-set-modal-trigger');

  // The theme's own variant-picker web component, kept hidden — clicking its
  // radio for the picked tier (below) lets it run its real selectCombination()
  // flow and dispatch native variant:change/variant:changed events itself,
  // instead of us faking that shape by hand.
  const hiddenVariantPicker = root.querySelector('variant-picker[hidden]');

  // <product-media>'s own variant:change listener is bound to the *standard*
  // product form (product_form_id in main-product.liquid), not
  // bundle-parent-add-form — so a tier switch never reaches it that way. Its
  // <flickity-carousel> exposes the same select() the theme's own
  // _onVariantChanged() uses (theme.js, ProductMedia class), so tier
  // selection below calls that directly instead.
  const productMediaCarousel = document.querySelector('product-media')?.mainCarousel;

  const setSlides = modal ? Array.from(modal.querySelectorAll('.bundle-set-modal__slide[data-slide-type="set"]')) : [];
  const reviewSlide = modal ? modal.querySelector('.bundle-set-modal__slide[data-slide-type="review"]') : null;
  const headingEl = modal ? modal.querySelector('[data-bundle-heading]') : null;
  const stepsContainer = modal ? modal.querySelector('[data-bundle-steps]') : null;
  const prevButton = modal ? modal.querySelector('.bundle-set-modal__prev') : null;
  const nextButton = modal ? modal.querySelector('.bundle-set-modal__next') : null;
  const embroideryYesButton = modal ? modal.querySelector('.bundle-set-modal__embroidery-yes') : null;
  const atcButtonText = atcButton.querySelector('.bundle__atc-btn--text');
  const navPriceEl = modal ? modal.querySelector('[data-bundle-nav-price]') : null;
  const overviewList = modal ? modal.querySelector('[data-bundle-overview]') : null;

  // Mobile-only "Review Your Bundle" sheet — see bundle-set-modal.liquid's
  // .bundle-set-modal__review-bar/-header/-footer. Desktop never toggles
  // .is-reviewing since the review bar that opens it is CSS-hidden there.
  const bodyEl = modal ? modal.querySelector('[data-bundle-body]') : null;
  const reviewMetaEl = modal ? modal.querySelector('[data-bundle-review-meta]') : null;
  const reviewPriceEl = modal ? modal.querySelector('[data-bundle-review-price]') : null;
  const openReviewButton = modal ? modal.querySelector('[data-action="open-review"]') : null;
  const closeReviewButtons = modal ? modal.querySelectorAll('[data-action="close-review"]') : [];

  // The main product price (product-meta) reflects whatever the selected tier
  // variant actually costs — observed instead of read once, since anything
  // that can rewrite it (variant swap, currency conversion) should also
  // trigger a recompute of the modal's price (which adds the Zip surcharge
  // below on top of the tier's own base price).
  const mainPriceEl = document.querySelector('.product-meta__price-list-container .price.price--large');

  // A top styled "Zip" (e.g. "Zip Front Scrub Top") costs $100 more per set —
  // cosmetic only, shown in the modal's running total. Doesn't touch the real
  // variant price, so it has no effect on what's actually charged at checkout.
  const ZIP_SURCHARGE_CENTS = 10000;

  function getZipSurchargeCents() {
    let total = 0;

    setCards.forEach((card) => {
      if (card.hidden) return;

      const topLabel = card.querySelector('.bundle-piece[data-piece="top"] .select__selected-value');
      if (topLabel && /zip/i.test(topLabel.textContent)) {
        total += ZIP_SURCHARGE_CENTS;
      }
    });

    return total;
  }

  // mainPriceEl's displayed text is the source of truth for the tier's base
  // cost — the Product Personalizer app rewrites it directly (not a real
  // variant change) whenever a paid add-on is toggled, and a currency
  // conversion app rewriting it stays correct too since this reads whatever
  // is actually on screen. Falls back to the tier radio's own static cents
  // only if mainPriceEl isn't there yet or its text doesn't parse.
  function parseMoneyToCents(text) {
    if (!text) return 0;

    const cleaned = text.replace(/[^0-9.,]/g, '');
    const decimalMatch = cleaned.match(/^(.*?)[.,](\d{2})$/);

    const integerPart = decimalMatch ? decimalMatch[1].replace(/[.,]/g, '') : cleaned.replace(/[.,]/g, '');
    const decimalPart = decimalMatch ? decimalMatch[2] : '00';

    if (!integerPart) return 0;

    return parseInt(integerPart, 10) * 100 + parseInt(decimalPart, 10);
  }

  function getBaseCents(checkedTier) {
    const parsedFromMain = mainPriceEl ? parseMoneyToCents(mainPriceEl.textContent) : 0;
    if (parsedFromMain) return parsedFromMain;

    return parseInt(checkedTier.dataset.priceCents || '0', 10);
  }

  function updateBundlePrice() {
    if (!navPriceEl) return;

    const checkedTier = Array.from(tierRadios).find((radio) => radio.checked);
    if (!checkedTier) return;

    const baseCents = getBaseCents(checkedTier);
    const totalCents = baseCents + getZipSurchargeCents();
    // formatMoney returns the store's money_format markup (e.g. a
    // <span class="trans-money"> wrapper for currency-conversion apps to
    // hook), so this has to go in as HTML, not escaped text.
    const formatted = formatMoney(totalCents);

    navPriceEl.innerHTML = formatted;
    if (reviewPriceEl) reviewPriceEl.innerHTML = formatted;
  }

  if (mainPriceEl && navPriceEl) {
    new MutationObserver(updateBundlePrice).observe(mainPriceEl, {
      characterData: true,
      childList: true,
      subtree: true
    });
    updateBundlePrice();
  }

  const CHECK_ICON_SVG =
    '<svg focusable="false" width="12" height="12" viewBox="0 0 32 32"><path d="M24.59 8L12.9885 20.6731L7.31806 15.1819L6 16.6956L12.3755 22.8792L13.0805 23.5556L13.7395 22.8309L26 9.43318L24.59 8Z" fill="currentColor"></path></svg>';

  const PERSONALIZATION_THUMB_URL =
    'https://cdn.shopify.com/s/files/1/0707/4621/0590/files/thread.jpg?v=1786334338';

  let currentSlideIndex = 0;

  // A set is only really "ready" if both its pieces have a color AND a size chosen
  // in whichever style block is currently visible for that piece. This is
  // independent of which slide the slider is currently showing — a set card keeps
  // its own `hidden` state (beyond the tier's set count or not), separate from the
  // slide wrapper's `hidden` (current nav position or not).
  function updateSetStatus(card) {
    const isComplete = Array.from(card.querySelectorAll('.bundle-piece')).every((piece) => {
      const activeStyleBlock = piece.querySelector('.bundle-style-block:not([hidden])');
      if (!activeStyleBlock) return false;

      const colorChecked = activeStyleBlock.querySelector('.color-swatch-list input[type="radio"]:checked');
      const sizeChecked = activeStyleBlock.querySelector('.bundle-size-panels input[type="radio"]:checked');

      if (!colorChecked || !sizeChecked) return false;

      // The swatch inputs themselves aren't given a `disabled` attribute (see
      // bundle-set-piece.liquid) — out-of-stock is only marked visually via
      // `.is-disabled` on the wrapping swatch — so a customer can still click
      // one and land on a variant that can't actually be added to cart. Treat
      // that the same as nothing being picked.
      const colorAvailable = !colorChecked.closest('.color-swatch')?.classList.contains('is-disabled');
      const sizeAvailable = !sizeChecked.closest('.block-swatch')?.classList.contains('is-disabled');

      return colorAvailable && sizeAvailable;
    });

    card.dataset.status = isComplete ? 'ready' : 'incomplete';

    const statusText = card.querySelector('.bundle-set-card__status-text');
    if (statusText) statusText.textContent = isComplete ? 'READY' : 'INCOMPLETE';
  }

  // The Color field shows the currently checked swatch's own color (a small
  // dot, copying the exact background the real swatch list already computed
  // server-side via the color-swatch-style snippet) plus its name, next to
  // the "Color" label — see bundle-set-piece.liquid's [data-color-swatch]/
  // [data-color-name].
  function updateColorNameLabel(styleBlock) {
    const nameEl = styleBlock.querySelector('[data-color-name]');
    const swatchEl = styleBlock.querySelector('[data-color-swatch]');
    if (!nameEl && !swatchEl) return;

    const checkedColor = styleBlock.querySelector('.color-swatch-list input[type="radio"]:checked');
    const swatchItem = checkedColor?.closest('.color-swatch')?.querySelector('.color-swatch__item');
    const colorName = swatchItem?.querySelector('.visually-hidden')?.textContent.trim();

    if (nameEl) nameEl.textContent = colorName || '';

    if (swatchEl) {
      swatchEl.style.cssText = swatchItem ? swatchItem.style.cssText : '';
      swatchEl.hidden = !swatchItem;
    }
  }

  // The gift picker lives only inline in the checked tier's own card (expands on
  // selection) — the modal no longer has its own copy, just a read-only summary
  // of whatever's chosen there.
  function getActiveGiftPanel() {
    const checkedTier = root.querySelector('.bundle-tier-card__radio:checked');
    return checkedTier?.closest('.bundle-tier-card')?.querySelector('.bundle-gift-picker') || null;
  }

  // A gift-less tier has no .bundle-gift-picker at all — nothing to require.
  function giftRequiresChoice(giftPanel) {
    return Boolean(giftPanel?.querySelector('.bundle-gift-option'));
  }

  // One level down, the gift *option* (which product) only decides which
  // gift-size-panel is shown — the actual variant to add to cart comes from
  // whichever size is checked inside that panel (or the single hidden radio a
  // one-variant gift carries instead of a real size picker).
  function getActiveGiftRadio() {
    const giftPanel = getActiveGiftPanel();
    if (!giftPanel) return null;

    const options = Array.from(giftPanel.querySelectorAll('.bundle-gift-option'));
    const optionIndex = options.findIndex((option) => option.querySelector('.bundle-gift-option__radio:checked'));
    if (optionIndex === -1) return null;

    const sizePanel = giftPanel.querySelectorAll('.bundle-gift-size-panel')[optionIndex];
    return sizePanel ? sizePanel.querySelector('input[type="radio"]:checked') : null;
  }

  // --- Slider navigation ---

  // Only the checked tier's own set count is ever navigable — a smaller tier
  // simply never surfaces the later Set slides, regardless of how many were
  // pre-rendered for the largest tier.
  function getActiveSlides() {
    const checkedTier = root.querySelector('.bundle-tier-card__radio:checked');
    const setCount = parseInt(checkedTier?.dataset.setCount || '1', 10);
    const activeSetSlides = setSlides.filter((slide) => parseInt(slide.dataset.setIndex || '0', 10) <= setCount);

    return reviewSlide ? [...activeSetSlides, reviewSlide] : activeSetSlides;
  }

  // One step per active Set slide, PLUS a final "Customize" step for the
  // embroidery-prompt slide — so the stepper always reflects every slide the
  // customer can actually land on (getActiveSlides() already includes it as the
  // last entry). A step reads as done (checkmark) once its set is ready AND it's
  // no longer the current step; the current step always shows its number, even
  // if that set happens to be ready already, so the customer always has a clear
  // "you are here" marker. The Customize step never shows a checkmark — there's
  // no set-readiness concept for it, just "not yet there" or "here". Steps are
  // clickable, but jumping AHEAD is gated the same way the Next button is —
  // revisiting an earlier step is always free, since nothing there needs to
  // become "more ready" first.
  function canNavigateToStep(targetIndex) {
    if (targetIndex <= currentSlideIndex) return true;

    const slides = getActiveSlides();

    for (let i = currentSlideIndex; i < targetIndex; i += 1) {
      const slide = slides[i];
      if (!slide || slide === reviewSlide) continue;

      const setCard = slide.querySelector('.bundle-set-card');
      if (setCard?.dataset.status !== 'ready') return false;
    }

    return true;
  }

  function renderSteps() {
    if (!stepsContainer) return;

    const slides = getActiveSlides();

    stepsContainer.innerHTML = slides
      .map((slide, index) => {
        const isReview = slide === reviewSlide;
        const label = isReview ? 'Customize' : `Set ${slide.dataset.setIndex}`;
        const number = isReview ? slides.length : slide.dataset.setIndex;
        const isCurrent = index === currentSlideIndex;
        const isDone = !isReview && slide.querySelector('.bundle-set-card')?.dataset.status === 'ready';
        const showCheck = isDone && !isCurrent;
        const connector = index < slides.length - 1 ? '<span class="bundle-set-modal__step-connector"></span>' : '';

        return `
          <button
            type="button"
            class="bundle-set-modal__step${isCurrent ? ' is-current' : ''}${isDone ? ' is-done' : ''}"
            data-step-index="${index}"
          >
            <span class="bundle-set-modal__step-circle">${showCheck ? CHECK_ICON_SVG : number}</span>
            <span class="bundle-set-modal__step-label">${label}</span>
          </button>
          ${connector}
        `;
      })
      .join('');

    stepsContainer.querySelectorAll('[data-step-index]').forEach((button) => {
      button.addEventListener('click', () => {
        const targetIndex = parseInt(button.dataset.stepIndex, 10);
        if (!canNavigateToStep(targetIndex)) return;

        showSlide(targetIndex);
      });
    });
  }

  function updateHeading() {
    if (!headingEl) return;

    const checkedTier = root.querySelector('.bundle-tier-card__radio:checked');
    const setCount = parseInt(checkedTier?.dataset.setCount || '1', 10);

    headingEl.textContent = `Build Your ${setCount}-Set Bundle`;
  }

  // The Next button only ever moves off the *current* Set slide, so it only
  // needs to gate on that one set's readiness — not every set in the tier
  // (that's what updateAtcGating(), for the Review slide's Add to Cart, is
  // for). Re-run on every color/size pick, not just on showSlide(), so the
  // button unlocks the moment a set actually becomes ready rather than only
  // after the next slide change.
  function updateNextButtonGating() {
    if (!nextButton) return;

    const slides = getActiveSlides();
    const currentSlide = slides[currentSlideIndex];
    if (!currentSlide || currentSlide === reviewSlide) return;

    const setCard = currentSlide.querySelector('.bundle-set-card');
    nextButton.disabled = setCard?.dataset.status !== 'ready';
  }

  function showSlide(index) {
    const slides = getActiveSlides();
    if (!slides.length) return;

    currentSlideIndex = Math.max(0, Math.min(index, slides.length - 1));

    setSlides.forEach((slide) => {
      slide.hidden = true;
    });
    if (reviewSlide) reviewSlide.hidden = true;

    slides.forEach((slide, i) => {
      slide.hidden = i !== currentSlideIndex;
    });

    renderSteps();
    renderOverview();

    if (prevButton) prevButton.disabled = currentSlideIndex === 0;

    const onReviewSlide = slides[currentSlideIndex] === reviewSlide;
    if (nextButton) nextButton.hidden = onReviewSlide;
    if (atcButton) atcButton.hidden = !onReviewSlide;
    if (embroideryYesButton) embroideryYesButton.hidden = !onReviewSlide;

    updateNextButtonGating();

    if (onReviewSlide) {
      updateAtcGating();
    } else {
      // Leaving the review slide (Back, or reopening the modal) resets the
      // embroidery prompt back to its initial state, so returning to it later
      // never shows the personalizer's fields already revealed with no "Yes"
      // button to explain why.
      resetEmbroideryPromptState();
    }
  }

  // Shared by showSlide()'s "left the review slide" branch and the prevButton
  // handler's "undo Yes, Add Embroidery without leaving the slide" branch below
  // — just the class/label reset. Doesn't touch embroideryYesButton's hidden
  // state, since the two callers need opposite things there (showSlide is about
  // to hide it again for a non-review slide; the prevButton case needs it back).
  function resetEmbroideryPromptState() {
    reviewSlide?.classList.remove('is-customizing');
    if (atcButtonText) atcButtonText.textContent = 'No thanks, Checkout';
  }

  function goToSlide(delta) {
    showSlide(currentSlideIndex + delta);
  }

  prevButton?.addEventListener('click', () => {
    const isCustomizing = reviewSlide && !reviewSlide.hidden && reviewSlide.classList.contains('is-customizing');

    if (isCustomizing) {
      // "Back" while the personalizer's fields are showing undoes "Yes, Add
      // Embroidery" instead of leaving the slide entirely — the customer is
      // still on the same "want embroidery?" step, just changing their mind.
      // Whatever they'd already typed/picked in there gets cleared too, so it
      // can't ride along silently if they say "No thanks" afterward.
      resetEmbroideryPromptState();
      if (embroideryYesButton) embroideryYesButton.hidden = false;

      const personalizerRoot = findPersonalizerRoot();
      if (personalizerRoot) clearFields(personalizerRoot);

      updateAtcGating();
      return;
    }

    goToSlide(-1);
  });

  nextButton?.addEventListener('click', () => goToSlide(1));

  // Reopening the modal (e.g. after switching tiers) should never leave the
  // customer stranded on a slide the new tier doesn't have — always land back on
  // the first slide.
  if (modal) {
    document.addEventListener('openable-element:open', (event) => {
      if (event.target !== modal) return;
      closeReviewMode();
      updateHeading();
      showSlide(0);
      updateAtcGating();
    });
  }

  function summaryLabel(text) {
    return `<span class="bundle-set-modal__summary-label">${text}</span>`;
  }

  // Mobile's Review Your Bundle sheet shows a "Complete" tag next to any
  // section that's actually done — desktop doesn't display it, but it's cheap
  // to compute regardless of which layout is active.
  function sectionHeader(text, isComplete) {
    const status = isComplete ? '<span class="bundle-set-modal__overview-status">Complete</span>' : '';
    return `<div class="bundle-set-modal__overview-header">${summaryLabel(text)}${status}</div>`;
  }

  // Same idea as summaryLine, but a product image thumbnail instead of a color
  // dot — used by the left-column overview instead of the Review slide's cards.
  function overviewLine(imageUrl, text) {
    const thumb = imageUrl
      ? `<img class="bundle-set-modal__overview-thumb" src="${imageUrl}" alt="" loading="lazy">`
      : '<span class="bundle-set-modal__overview-thumb bundle-set-modal__overview-thumb--empty"></span>';

    return `
      <div class="bundle-set-modal__overview-line">
        ${thumb}
        <span>${text}</span>
      </div>
    `;
  }

  // Returns null when NEITHER a color nor a size is checked yet — i.e. this
  // piece hasn't been touched at all (relevant for Set 2+, which no longer
  // start with anything preselected). A piece with a color but no size (or vice
  // versa) still reports partial info rather than disappearing.
  function pieceSummary(piece) {
    const activeStyleBlock = piece.querySelector('.bundle-style-block:not([hidden])');
    if (!activeStyleBlock) return null;

    const checkedColor = activeStyleBlock.querySelector('.color-swatch-list input[type="radio"]:checked');
    const checkedSize = activeStyleBlock.querySelector('.bundle-size-panels input[type="radio"]:checked');

    if (!checkedColor && !checkedSize) return null;

    const styleName = piece.querySelector('.select__selected-value')?.textContent.trim();
    const colorSwatch = checkedColor?.closest('.color-swatch')?.querySelector('.color-swatch__item');
    const colorLabel = colorSwatch?.querySelector('.visually-hidden')?.textContent.trim();
    const sizeLabel = checkedSize?.closest('.block-swatch')?.querySelector('.block-swatch__item')?.textContent.trim();

    const text = `${styleName} - ${colorLabel || '—'} / ${sizeLabel || '—'}`;

    return {
      imageUrl: checkedColor?.dataset.image || '',
      text
    };
  }

  // --- Left-column overview — a lighter, always-visible sibling of the Review
  // slide's summary (no Edit links, no card borders, product thumbnails instead
  // of color dots, no Top/Pants labels): "Gift Chosen" plus each in-tier set's
  // picks, rebuilt on every change so it's never stale regardless of which slide
  // the customer is currently on. A set with nothing chosen for either piece
  // yet (Set 2+, which no longer preselects anything — see bundle-set-piece.liquid)
  // is skipped entirely rather than showing up with default values the customer
  // never actually picked. ---

  // The "Set N" master toggle only reveals that set's fields — it doesn't mean
  // the customer actually added anything. The real signal is one of the paid
  // add-on checkboxes actually being checked (e.g. "Add Name & Designation",
  // "Add Back Embroidery", "Add Logo" — every one of the app's add-on fields
  // names itself "Add ..."), scoped to this set's own container so Set 2's
  // add-ons don't light up Set 1's line.
  function isSetPersonalized(setIndex) {
    const personalizerRoot = findPersonalizerRoot();
    if (!personalizerRoot) return false;

    const container = personalizerRoot.querySelector(`.pplr-set-container-${setIndex}`) || personalizerRoot;

    return Array.from(container.querySelectorAll('input[type="checkbox"]:checked')).some((input) =>
      input.name.includes('Add')
    );
  }

  function renderOverview() {
    if (!overviewList) return;

    const sections = [];

    const giftPanel = getActiveGiftPanel();

    if (giftRequiresChoice(giftPanel)) {
      const checkedGiftOption = giftPanel
        .querySelector('.bundle-gift-option__radio:checked')
        ?.closest('.bundle-gift-option');
      const giftName = checkedGiftOption?.querySelector('.bundle-gift-option__name')?.textContent.trim();
      const giftImageUrl = checkedGiftOption?.querySelector('.bundle-gift-option__img')?.getAttribute('src') || '';
      const giftSizeLabel = getActiveGiftRadio()
        ?.closest('.block-swatch')
        ?.querySelector('.block-swatch__item')
        ?.textContent.trim();

      const giftText = giftName
        ? `${giftName}${giftSizeLabel ? ` · Size ${giftSizeLabel}` : ''}`
        : 'Not selected';

      sections.push(`
        <div class="bundle-set-modal__overview-section">
          ${sectionHeader('Gift Chosen', giftSatisfied())}
          ${overviewLine(giftImageUrl, giftText)}
        </div>
      `);
    }

    Array.from(root.querySelectorAll('.bundle-set-card:not([hidden])')).forEach((card) => {
      const setIndex = card.dataset.setIndex;
      const [topPiece, pantsPiece] = card.querySelectorAll('.bundle-piece');
      const top = pieceSummary(topPiece);
      const pants = pieceSummary(pantsPiece);

      if (!top && !pants) return;

      const personalized = isSetPersonalized(setIndex);

      sections.push(`
        <div class="bundle-set-modal__overview-section">
          ${sectionHeader(`Set ${setIndex}`, card.dataset.status === 'ready')}
          ${top ? overviewLine(top.imageUrl, top.text) : ''}
          ${pants ? overviewLine(pants.imageUrl, pants.text) : ''}
          ${personalized ? overviewLine(PERSONALIZATION_THUMB_URL, 'Customization Added') : ''}
        </div>
      `);
    });

    overviewList.innerHTML = sections.join('');
  }

  // --- Add to Cart / embroidery-prompt gating — both buttons start disabled and
  // only enable once every in-tier set is ready and the gift (if the tier has
  // one) is chosen. Same requirement either way: there has to be a complete,
  // valid bundle before offering to add it to cart OR to go customize it. ---

  function allSetsReady() {
    return Array.from(root.querySelectorAll('.bundle-set-card:not([hidden])')).every(
      (card) => card.dataset.status === 'ready'
    );
  }

  function giftSatisfied() {
    const giftPanel = getActiveGiftPanel();
    return !giftRequiresChoice(giftPanel) || Boolean(getActiveGiftRadio());
  }

  // Mobile-only "Your Bundle — N sets · N pieces · N gift" line above the Next/
  // Add to Cart nav — see bundle-set-modal.liquid's .bundle-set-modal__review-bar.
  // Piece count is structural (2 per set: Top + Pants), not selection-based, so
  // it reads the same whether or not every piece is actually chosen yet.
  function updateReviewBar() {
    if (!reviewMetaEl) return;

    const checkedTier = root.querySelector('.bundle-tier-card__radio:checked');
    const setCount = parseInt(checkedTier?.dataset.setCount || '0', 10);
    const giftCount = giftRequiresChoice(getActiveGiftPanel()) ? 1 : 0;

    const parts = [
      `${setCount} set${setCount === 1 ? '' : 's'}`,
      `${setCount * 2} piece${setCount * 2 === 1 ? '' : 's'}`
    ];
    if (giftCount) parts.push(`${giftCount} gift`);

    reviewMetaEl.textContent = parts.join(' · ');
  }

  // Mobile's "Review Your Bundle" sheet is just the same overview panel that's
  // always visible in desktop's left column, toggled full-screen via a class on
  // the body — see bundle-set-modal.liquid and the .is-reviewing CSS.
  function openReviewMode() {
    if (!bodyEl) return;

    renderOverview();
    if (reviewPriceEl && navPriceEl) reviewPriceEl.textContent = navPriceEl.textContent;

    bodyEl.classList.add('is-reviewing');
  }

  function closeReviewMode() {
    bodyEl?.classList.remove('is-reviewing');
  }

  openReviewButton?.addEventListener('click', openReviewMode);
  closeReviewButtons.forEach((button) => button.addEventListener('click', closeReviewMode));

  function updateAtcGating() {
    const isComplete = allSetsReady() && giftSatisfied();

    atcButton.disabled = !isComplete;
    if (embroideryYesButton) embroideryYesButton.disabled = !isComplete;
    updateReviewBar();

    // The gift is chosen from the tier card itself, before the modal ever
    // opens — "Select Products" shouldn't let the customer past that step
    // without it, same requirement updateAtcGating() already enforces for
    // Add to Cart once they're inside the modal.
    if (modalTriggerButton) modalTriggerButton.disabled = !giftSatisfied();
  }

  // The Product Personalizer app's customization fields render directly inside
  // this slide's form now (see bundle-set-modal.liquid), not on an external
  // #zepto section — so "Yes" just reveals them in place instead of closing
  // the modal. "No thanks, Checkout" becomes the actual Add to Cart action
  // once revealed (same #bundle__AddToCart click handler throughout, just
  // relabeled — it's no longer a "no" once the customer has opted in).
  embroideryYesButton?.addEventListener('click', () => {
    reviewSlide?.classList.add('is-customizing');
    embroideryYesButton.hidden = true;
    if (atcButtonText) atcButtonText.textContent = 'Add to Cart';
  });

  // Every field inside a wrapper we're hiding gets cleared (and told about it
  // via a real change event, in case the app's own JS is listening) so a value
  // the customer entered for a set that's no longer in scope can't ride along
  // silently when the native form submits. Only dispatched when something
  // actually changed — an already-empty field re-dispatching 'change' on every
  // call is how this used to feed an infinite loop: syncPplrSetVisibility()
  // runs on every modal DOM mutation, clearFields() unconditionally re-fired
  // 'change' on already-cleared fields, the modal's delegated 'change' listener
  // (see below) called renderOverview() for that, which mutates the DOM,
  // triggering syncPplrSetVisibility() again — forever, hanging the page.
  function clearFields(container) {
    container.querySelectorAll('input, textarea, select').forEach((field) => {
      let changed = false;

      if (field.type === 'checkbox' || field.type === 'radio') {
        if (field.checked) {
          field.checked = false;
          changed = true;
        }
      } else if (field.value !== '') {
        field.value = '';
        changed = true;
      }

      if (changed) field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // The app's own field labels have the set number baked into their visible
  // text too (e.g. "Set 1: Add Name & Designation"), redundant once the fields
  // are already grouped/hidden per set by the wrapper above — strip it out of
  // every text node in the form, not just inside .pplr-wrapper, since the app
  // doesn't consistently nest every labeled field the same way.
  function stripSetLabelPrefixes(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      if (/Set [123]:\s*/.test(node.textContent)) {
        node.textContent = node.textContent.replace(/Set [123]:\s*/g, '');
      }
      node = walker.nextNode();
    }
  }

  // The Product Personalizer app injects its widget as its own div, id
  // "pplr-<product id>" — NOT nested inside #bundle-parent-add-form. Its inputs
  // reach the form purely via an explicit form="bundle-parent-add-form"
  // attribute, so searching inside the <form> element (as this used to) never
  // finds anything. Only "main" fields (data-main="N") carry a pplr-set-N class
  // reliably; the conditional fields the app reveals later (Name Placement,
  // Font Type, etc.) start life as bare `data-pplr-ph="N"` placeholders with no
  // set-identifying class at all. Both attributes are just that field's frame
  // number in one continuous, in-order sequence though — every field between
  // the "Set 1" marker and the "Set 2" marker belongs to Set 1, and so on — so
  // that's what determines which set a field belongs to, not its class.
  function findPersonalizerRoot() {
    return modal ? modal.querySelector('[id^="pplr-"]') : null;
  }

  // Runs once per personalizer widget: walks its flat list of field divs in
  // DOM order, tracking which "Set N" marker was most recently passed, and
  // physically moves each field (and its still-empty data-pplr-ph placeholders)
  // into a container div per set. After this, hiding/clearing a whole set is
  // just one container to touch instead of re-deriving set membership from
  // frame numbers on every sync.
  function groupPplrFieldsBySet(personalizerRoot) {
    if (personalizerRoot.dataset.pplrGrouped) return;

    const containers = {
      1: document.createElement('div'),
      2: document.createElement('div'),
      3: document.createElement('div')
    };

    Object.keys(containers).forEach((setNumber) => {
      containers[setNumber].className = `pplr-set-container pplr-set-container-${setNumber}`;
      personalizerRoot.appendChild(containers[setNumber]);
    });

    let currentSetNumber = 1;

    Array.from(personalizerRoot.children).forEach((child) => {
      if (child === containers[1] || child === containers[2] || child === containers[3]) return;

      if (child.classList?.contains('pplr-set-1')) currentSetNumber = 1;
      else if (child.classList?.contains('pplr-set-2')) currentSetNumber = 2;
      else if (child.classList?.contains('pplr-set-3')) currentSetNumber = 3;

      if (!child.hasAttribute('data-main') && !child.hasAttribute('data-pplr-ph')) return;

      containers[currentSetNumber].appendChild(child);
    });

    personalizerRoot.dataset.pplrGrouped = 'true';
  }

  // Grouping only needs to happen once (the app keeps injecting more frames
  // into already-placed data-pplr-ph placeholders, not new top-level children),
  // but hide/show has to be re-applied on every tier change.
  function syncPplrSetVisibility() {
    const personalizerRoot = findPersonalizerRoot();
    if (!personalizerRoot) return;

    groupPplrFieldsBySet(personalizerRoot);

    const checkedTier = root.querySelector('.bundle-tier-card__radio:checked');
    const setCount = parseInt(checkedTier?.dataset.setCount || '1', 10);

    [1, 2, 3].forEach((setNumber) => {
      const container = personalizerRoot.querySelector(`.pplr-set-container-${setNumber}`);
      if (!container) return;

      const shouldHide = setNumber > setCount;
      container.hidden = shouldHide;

      if (shouldHide) clearFields(container);
    });

    stripSetLabelPrefixes(personalizerRoot);
  }

  // The app's own injection timing is opaque, and its widget can land anywhere
  // under the modal (not necessarily inside the form) — so rather than guessing
  // when it's ready, watch the whole modal and re-sync on every DOM change.
  if (modal) {
    new MutationObserver(syncPplrSetVisibility).observe(modal, {
      childList: true,
      subtree: true
    });

    // Checking/unchecking a "Set N" personalization toggle (or filling in its
    // fields) doesn't touch the DOM tree, so the MutationObserver above never
    // sees it — delegate 'change' instead, scoped to modal since it's the one
    // stable ancestor that exists before the app's own async injection does.
    // Cheap enough to just re-render on every personalizer change rather than
    // filtering down to only the Set N checkboxes specifically.
    modal.addEventListener('change', (event) => {
      if (!event.target.closest('[id^="pplr-"]')) return;
      renderOverview();
    });
  }

  // Shared by the change listener below AND the initial URL-preselect check on
  // load, so a tier picked via a ?variant= link ends up in the exact same state
  // (price, set count, heading, slide, gating) as one picked by clicking a card.
  function applyTierSelection(radio) {
    tierMessage?.classList.remove('error');

    // Keep the URL's variant param in sync with the picked tier, same as a
    // normal Shopify variant picker — makes the choice shareable/bookmarkable
    // and keeps it in sync with whatever variant actually goes to the native
    // Product Personalizer add-to-cart form (see triggerNativeParentAdd()).
    if (radio.value) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', radio.value);
      window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
    }

    // Click the hidden variant-picker's own radio for this tier so the theme's
    // VariantPicker component runs its real selectCombination() flow and fires
    // native variant:change/variant:changed events on bundle-parent-add-form —
    // any other component listening for those (dynamic checkout buttons, price
    // displays, etc.) reacts to a tier switch exactly like a normal variant pick.
    const matchingOptionRadio = hiddenVariantPicker?.querySelector(`input[data-variant-id="${radio.value}"]`);

    if (matchingOptionRadio && !matchingOptionRadio.checked) {
      matchingOptionRadio.checked = true;
      matchingOptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Switch the product gallery to whichever image this tier variant has
    // set as its featured media — see productMediaCarousel's declaration
    // above for why this can't just ride the variant:change event above.
    if (productMediaCarousel && radio.dataset.featuredMediaId) {
      productMediaCarousel.select(`[data-media-id="${radio.dataset.featuredMediaId}"]`);
    }

    // The tier determines how many sets are in scope for validation/gating —
    // independent of the slider's own current nav position.
    const setCount = parseInt(radio.dataset.setCount || '1', 10);

    setCards.forEach((card) => {
      const cardIndex = parseInt(card.dataset.setIndex || '0', 10);
      const isVisible = cardIndex <= setCount;

      card.hidden = !isVisible;

      if (isVisible) {
        const totalLabel = card.querySelector('.bundle-set-card__total');
        if (totalLabel) totalLabel.textContent = pad(setCount);
      }
    });

    // Keep the nav's price in sync with whichever tier is currently picked
    // (plus any Zip-top surcharge) now that set visibility above reflects the
    // new tier's set count — not repeated on the Add to Cart button's own
    // label, which stays a plain "No, Add to Cart" so it doesn't wrap on the
    // embroidery-prompt slide.
    updateBundlePrice();

    // Re-check the app's injected .pplr-set-* panels too, in case they're
    // already there by the time the tier changes (the observer above only
    // catches injections that happen *after* this point).
    syncPplrSetVisibility();

    updateHeading();
    showSlide(0);
    updateAtcGating();
  }

  tierRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      applyTierSelection(radio);
    });
  });

  // A ?variant=<id> in the URL (shared/bookmarked link, or the browser back/
  // forward button after replaceState above) should land on that tier instead
  // of whatever the server preselected by default.
  const urlVariantId = new URL(window.location.href).searchParams.get('variant');

  if (urlVariantId) {
    const matchingRadio = Array.from(tierRadios).find((radio) => radio.value === urlVariantId);

    if (matchingRadio) {
      matchingRadio.checked = true;
      applyTierSelection(matchingRadio);
    }
  }

  const pieces = root.querySelectorAll('.bundle-piece');

  pieces.forEach((piece) => {
    const setCard = piece.closest('.bundle-set-card');

    // Picking a different color invalidates whatever size was chosen for the old one
    // (each color has its own size panel/variants), so force a fresh size choice —
    // scoped per style block, since each style has its own independent color/size set.
    piece.querySelectorAll('.bundle-style-block').forEach((styleBlock) => {
      const colorInputs = styleBlock.querySelectorAll('.color-swatch-list input[type="radio"]');
      const sizeInputs = styleBlock.querySelectorAll('.bundle-size-panels input[type="radio"]');

      colorInputs.forEach((input) => {
        input.addEventListener('change', () => {
          sizeInputs.forEach((sizeInput) => {
            sizeInput.checked = false;
          });

          updateColorNameLabel(styleBlock);

          if (setCard) {
            updateSetStatus(setCard);
            updateAtcGating();
            updateNextButtonGating();
          }
          renderOverview();
        });
      });

      sizeInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (setCard) {
            updateSetStatus(setCard);
            updateAtcGating();
            updateNextButtonGating();
          }
          renderOverview();
        });
      });
    });

    // Picking a different style swaps which pre-rendered color/size block is shown.
    // The theme's combo-box JS only updates a hidden input's value on click — it
    // doesn't touch the closed-state label or anything outside the combo-box, so
    // both of those are handled here instead.
    const selectedValueLabel = piece.querySelector('.select__selected-value');

    piece.querySelectorAll('.combo-box__option-item[data-style-id]').forEach((option) => {
      option.addEventListener('click', () => {
        if (selectedValueLabel && option.dataset.styleLabel) {
          selectedValueLabel.textContent = option.dataset.styleLabel;
        }

        piece.querySelectorAll('.bundle-style-block').forEach((styleBlock) => {
          styleBlock.hidden = styleBlock.dataset.styleId !== option.dataset.styleId;
          if (!styleBlock.hidden) updateColorNameLabel(styleBlock);
        });

        if (setCard) {
          updateSetStatus(setCard);
          updateAtcGating();
          updateNextButtonGating();
        }
        renderOverview();

        // A Zip-styled top adds a surcharge to the running total — only the
        // Top piece affects it, but recomputing is cheap and this stays
        // correct even if a Zip style is ever added to Pants too.
        updateBundlePrice();
      });
    });
  });

  // Gift options don't gate anything by themselves (validation reads the checked
  // radio directly), but the Add to Cart button and the live overview summary
  // both need to react to a gift choice changing.
  root.querySelectorAll('.bundle-gift-option__radio, .bundle-gift-size-panels input[type="radio"]').forEach((input) => {
    input.addEventListener('change', () => {
      updateAtcGating();
      renderOverview();
    });
  });

  // Everything is preselected by default, but confirm the real DOM state on load
  // rather than assuming the server-rendered "ready" status always holds.
  root.querySelectorAll('.bundle-style-block:not([hidden])').forEach(updateColorNameLabel);
  setCards.forEach((card) => updateSetStatus(card));
  updateAtcGating();
  renderOverview();

  atcButton.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (isAdding) return;

    const atcText = atcButton.querySelector('.bundle__atc-btn--text');
    const atcLoader = atcButton.querySelector('.loader-button__loader');

    atcText.style.opacity = '0';
    atcLoader?.removeAttribute('hidden');
    isAdding = true;

    // Everything from here down is wrapped in this one try/finally so the button's
    // text/loader always get restored — validation used to run outside any
    // try/catch, so a validation-time error (or any other unexpected throw) would
    // leave the button permanently blank with no way to recover.
    try {
      let validationSuccess = true;

      const checkedTier = root.querySelector('.bundle-tier-card__radio:checked');

      if (!checkedTier) {
        validationSuccess = false;
        tierMessage?.classList.add('error');
      } else {
        tierMessage?.classList.remove('error');
      }

      // Only in-tier set cards need a color + size chosen, and only within
      // whichever style block is currently shown for that piece — this is
      // independent of which slide the slider happens to be showing.
      root.querySelectorAll('.bundle-set-card:not([hidden]) .bundle-piece').forEach((piece) => {
        const activeStyleBlock = piece.querySelector('.bundle-style-block:not([hidden])');
        if (!activeStyleBlock) return;

        const groups = [
          {
            container: activeStyleBlock.querySelector('.color-swatch-list'),
            message: activeStyleBlock.querySelector('[data-field="color"] .field-message')
          },
          {
            container: activeStyleBlock.querySelector('.bundle-size-panels'),
            message: activeStyleBlock.querySelector('[data-field="size"] .field-message')
          }
        ];

        groups.forEach(({ container, message }) => {
          if (!container) return;

          const checkedInput = container.querySelector('input[type="radio"]:checked');

          if (!checkedInput) {
            validationSuccess = false;
            message?.classList.add('error');
          } else {
            message?.classList.remove('error');
          }
        });
      });

      const giftPanel = getActiveGiftPanel();
      const giftMessage = giftPanel?.querySelector('.field-message');
      const checkedGift = getActiveGiftRadio();

      if (giftRequiresChoice(giftPanel) && !checkedGift) {
        validationSuccess = false;
        giftMessage?.classList.add('error');
      } else {
        giftMessage?.classList.remove('error');
      }

      if (!validationSuccess) {
        console.log('[Bundle Validation] Required fields missing');
        showNotification('Please fill in required fields.');
        return;
      }

      const parentVariantId = Number(
        root.querySelector('.bundle-tier-card__radio:checked')?.value
      );

      const childVariants = [];

      root.querySelectorAll('.bundle-set-card:not([hidden]) .bundle-piece').forEach((piece) => {
        const checkedSize = piece.querySelector(
          '.bundle-style-block:not([hidden]) .bundle-size-panels input[type="radio"]:checked'
        );
        if (!checkedSize) return;

        const raw = checkedSize.getAttribute('data-atc-value');
        if (!raw || !raw.includes('|')) return;

        const variantId = Number(raw.split('|')[1]);
        if (!variantId) return;

        const setIndex = piece.closest('.bundle-set-card')?.dataset.setIndex;
        childVariants.push({ variantId, setIndex });
      });

      const giftVariantId = Number(checkedGift?.value) || null;

      if (!parentVariantId || !childVariants.length) {
        console.error('[Bundle Debug] Missing parent or child variants');
        showNotification('Unable to add bundle. Please try again.');
        return;
      }

      const bundleId = `Bundle-${Date.now()}`;

      // The parent goes through the real product form (see bundle-set-modal.liquid)
      // instead of our own AJAX call, so the Product Personalizer app's click
      // handler actually runs — it's what attaches the customization properties
      // and adds its own "price adjustment" product alongside the parent. That
      // click redirects to /cart the instant the app is done (confirmed — no
      // window to poll cart.js for the parent's resulting line key before
      // navigation happens), so real parent/child nesting can't be set up here.
      // Instead we stash what still needs adding and let cart-bundle-fulfill.js
      // finish the job on the cart page itself, once the parent line actually
      // exists to reference via parent_line_key.
      const parentTriggered = triggerNativeParentAdd(parentVariantId, bundleId);

      if (parentTriggered) {
        sessionStorage.setItem('pendingBundleChildren', JSON.stringify({
          bundleId,
          childVariants,
          giftVariantId
        }));
        return;
      }

      // No Personalizer form on this page — we control the whole request, so
      // parent and children can go in one call with `parent_id`, which is
      // Shopify's real nested-cart-line linkage (only valid when parent and
      // child are submitted together in the same request).
      console.warn('[Bundle Debug] Native parent add-to-cart form not found — falling back to AJAX for parent + children in one request.');

      const items = [
        {
          id: parentVariantId,
          quantity: 1,
          properties: {
            'Bundle ID': bundleId,
            Type: 'August Bundle',
            Role: 'Parent'
          }
        }
      ];

      childVariants.forEach(({ variantId, setIndex }) => {
        items.push({
          id: variantId,
          quantity: 1,
          parent_id: parentVariantId,
          properties: {
            'Bundle ID': bundleId,
            Type: 'August Bundle',
            Role: 'Child',
            Set: `Set ${setIndex}`
          }
        });
      });

      if (giftVariantId) {
        items.push({
          id: giftVariantId,
          quantity: 1,
          parent_id: parentVariantId,
          properties: {
            'Bundle ID': bundleId,
            Type: 'August Bundle',
            Role: 'Gift'
          }
        });
      }

      const parentResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!parentResponse.ok) {
        const errorText = await parentResponse.text();
        throw new Error(errorText);
      }

      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (error) {
      console.error('[Bundle Debug] Add to cart error:', error);

      let errorMessage = 'Add to cart failed. Please try again.';

      try {
        const parsedError = JSON.parse(error.message);

        if (parsedError?.status === 422 && parsedError?.description) {
          errorMessage = parsedError.description;
        }
      } catch (parseError) {
        console.warn('[Bundle Debug] Could not parse error message:', parseError);
      }

      showNotification(errorMessage);
    } finally {
      isAdding = false;
      atcText.style.opacity = '1';
      atcLoader?.setAttribute('hidden', '');
    }
  });
});
